import React from 'react';
import { Check } from 'lucide-react';
import { FLOW, STATUS_META } from './shared';

// Open → In progress → Ready are clickable; Invoiced only happens by billing.
export const StatusStepper = ({ status, onChange, locked }) => {
  const at = FLOW.indexOf(status);
  return (
    <ol className="flex flex-wrap items-center gap-2" data-testid="jc-status-stepper">
      {FLOW.map((key, idx) => {
        const done = at >= 0 && idx < at;
        const current = key === status;
        const clickable = !locked && key !== 'invoiced';
        return (
          <li key={key} className="flex items-center gap-2">
            <button
              type="button"
              disabled={!clickable}
              onClick={() => onChange(key)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${current ? 'border-teal-600 bg-teal-600 text-white' : done ? 'border-teal-200 bg-teal-50 text-teal-800' : 'border-slate-200 bg-white text-slate-500'} ${clickable ? 'hover:border-teal-400' : 'cursor-default'}`}
              data-testid={`jc-status-${key}`}
            >
              {done && <Check size={12} />}
              {STATUS_META[key].label}
            </button>
            {idx < FLOW.length - 1 && <span className="h-px w-5 bg-slate-300" />}
          </li>
        );
      })}
    </ol>
  );
};

export default StatusStepper;
